import { render, staticRenderFns } from "./DeleteFolderDialog.vue?vue&type=template&id=24bed49f&scoped=true"
import script from "./DeleteFolderDialog.vue?vue&type=script&lang=js"
export * from "./DeleteFolderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bed49f",
  null
  
)

export default component.exports